import fetchServer from "../../../fetchServer";

/**
 * POST /product/v1/refund/declineBySupplier/:id
 * Admin records that the airline/supplier declined the refund.
 * Body: { reason, supplierResponseCode?, supplierResponse? }
 */
export default async function declineRefundBySupplier(id, data) {
  var result = {
    return: 0,
    msg: "Something went wrong recording supplier decline",
    data: [],
  };

  await fetchServer({
    method: "POST",
    url: `/product/v1/refund/declineBySupplier/${id}`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res.status === 201) {
          result = { return: 1, msg: "Successfull", data: res.data?.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
